import { useQuery } from "@tanstack/react-query";
import { getProjects } from "@/services/api.js";
import { reactQueryCacheAndRefetchOptions } from "@";

// Hook for fetching projects list for dropdowns/selects
export const useProjectsOptionsQuery = (search = {}) => {
  return useQuery({
    queryKey: ["projects-options"],
    queryFn: async () => {
      const { data } = await getProjects(1, null, search);

      if (!data.data) return [];

      // Map to options format for Select component
      return (
        data?.data?.map((project) => ({
          value: project.id,
          label: project.title,
        })) || []
      );
    },
    ...reactQueryCacheAndRefetchOptions,
  });
};
